import api from '../services/api';

const Apoiador = {
  create : async function (data) {
    return await api.post('apoiadores', data)
    .then(response=>response)
    .catch(error=>error);
  },

  // Habilita ('Ativo') ou desabilita ('Inativo') sem apagar (so administrador).
  alterarStatus : async function (id, status) {
    return await api.patch(`apoiadores/id/${id}/status`, { status })
    .then(response=>response)
    .catch(error=>error);
  },

  delete : async function (patrocinador_id) {
    return await api.delete(`apoiadores/id/${patrocinador_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Um item pelo id (usado pelas páginas de edição do painel administrativo).
  findById : async function (id) {
    return await api.get(`apoiadores/id/${id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Listagem paginada com busca opcional (usada pelas listas do painel administrativo).
  listar : async function (page = 1, limit = 10, busca = '') {
    const termo = (busca || '').trim();
    const url = termo
      ? `apoiadores/data/${encodeURIComponent(termo)}/${page}/${limit}?todos=1`
      : `apoiadores/all/${page}/${limit}?todos=1`;
    return await api.get(url)
    .then(response=>response)
    .catch(error=>error);
  },
  findAll : async function () {
    return await api.get('apoiadores/all/1/7')
    .then(response=>response)
    .catch(error=>error);
  },

  findSearch : async function (data) {
    return await api.get(`apoiadores/data/${data}/1/20`)
    .then(response=>response)
    .catch(error=>error);
  }
}

export default Apoiador;
